module.exports = __webpack_public_path__ + "static/media/(V)-11-acessorios.a2314125.jpg";